<tax-modal-header [closeFn]="closeModal.bind(this)">{{
  'account_payment.replenishment' | translate
}}</tax-modal-header>

<tax-modal-content>
  <div *ngIf="notification" class="notification">
    <tax-icon name="error"></tax-icon>
    <span data-qa="error-text">{{ notification | translate }}</span>
  </div>

  <form (ngSubmit)="openKtPayWidget()">
    <tax-input
      data-qa-input="sum"
      labelText="account_payment.replenishment.total"
      id="sum"
      name="sum"
      taxNumbersOnly
      [(ngModel)]="payment"
      [required]="true"
      [autofocus]="false"
      [clearable]="true"
    ></tax-input>
    <p class="payment_description grey-text" data-qa="description">
      {{ 'account_payment.replenishment.description' | translate }}
    </p>
  </form>
</tax-modal-content>

<tax-modal-footer>
  <button
    data-qa-button="pay"
    class="button_blue ui-kit-align-right"
    [disabled]="!payment"
    (click)="openKtPayWidget()"
  >
    {{ 'account_payment.replenishment.next' | translate }}
  </button>
</tax-modal-footer>
